<app-auth-navbar></app-auth-navbar>
<div class="cxy-page-header cxy-page-header-eur">
  <div class="d-flex justify-content-center flex-wrap position-absolute" style="top:100px;left:1%" *ngIf="screen_width>996 && offer?.status">
      <div class="col-9 px-3 text-center py-2 offer" style="background-color: #A0BF81;" [innerHTML]="offer.subject">
      </div>
      <div class="col-6 px-2 text-center mt-2 py-2 offer" style="background-color: #266DD3;" [innerHTML]="offer.message">
      </div>
  </div>
    <div class="cxy-page-container w-container">
        <div class="cxy-header-left kenya-header-left">
            <div>
                <div class="text-block-25"><span class="text-span-3">CAD</span> to <span class="text-span-4">GBP</span></div>
            </div>
            <div>
                <h1 class="heading-10"><strong>Send money to most of the EU cheaply</strong></h1>
            </div>
            <div>
                <div class="text-block-26 black">
                    Leverage N2Xpress' competitive fees and a secure transacting environment to send money from Canada to EU countries including Austria, Estonia, Finland, France, Germany, Portugal, Sweden, and more to fulfill your daily remittance needs. 
                  <br></div>
            </div>
        </div>
        <div class="cxy-header-right">
            <div class="calculator-panel">
                <div class="calculator-header">
                    <!-- <h1 class="hero-heading">Save more with <br>online money transfers</h1> -->
                    <h1 class="hero-heading custom-heroHeading">Send money from Canada to EU</h1>
                </div>
                <div class="form-block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" redirect="https://app.n2xpress.ca/login" data-redirect="https://app.n2xpress.ca/login" class="form">
                      <div class="div-block-13">
                          <input [(ngModel)]="amount" (keyup)="onAmountChange($event.target.value)" type="number" style="background:none!important; border:none;" class="text-field w-input m-0 p-3" def="10" autofocus="true" maxlength="256" name="Send" data-name="Send" placeholder="You send" id="currency-send" required="">
                          <div data-hover="" data-delay="0" class="w-dropdown">
                              <div class="dropdown  color-blue radiusr-5" style="height:50px"> 
                                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                                      <!-- Country -->
                                      {{ countryName }}  <img [src]="'assets/images/' + source + '.png'" class="ml-1" width="22" height="22">
                                      <!-- <i class="fas fa-angle-down pl-2"></i> -->
                                  </button> 
                                  
                                  <!-- <div class="dropdown-content"> 
                                      <a (click)="onSourceChange('cad','Canada')" class="d-flex justify-content-between align-items-center"> 
                                          Canada
                                          <img alt="CAD" src="assets/images/cad.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      
                                      <a (click)="onSourceChange('usd','USA')" class="d-flex justify-content-between align-items-center"> 
                                          USA
                                          <img alt="USA" src= "assets/images/usd.png" class="ml-1" width="20" height="20"> 
                                      </a> 
                                      
                                  </div>  -->
                              </div>
                              
                          </div>
                      </div>
                      <div class="rate-panel">
                          <div class="div-block-15"></div>
                          <div class="div-block-16">
                              <div class="div-block-17">
                                  <div>
                                      <div id="currency-fees" class="fee-figure">{{transactionFees}}</div>
                                  </div>
                                  <div class="rate-currency">
                                      <div id="fees-currency" class="rate-currency-text">{{source.toUpperCase()}}</div>
                                  </div>
                                  <div class="fee-explainer-text">
                                      <div class="explainer-text pl-3">Total fees</div>
                                  </div>
                              </div>
                              <div class="div-block-18">
                                  <div class="rate-figure">
                                      <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                                  </div>
                                  <div class="rate-currency">
                                      <div id="exchange-currency" class="rate-currency-text">{{destination_currency.toUpperCase()}}</div>
                                  </div>
                                  <div class="rate-explainer">
                                      <div class="explainer-text">Your exchange rate</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="div-block-13-copy">
                          <input [(ngModel)]="convertedAmount" readonly type="number"  style="background:none!important; border:none;" class="text-field w-input m-0 p-3" maxlength="256" name="Receive" data-name="Receive" placeholder="They receive" id="currency-receive">
                          <div data-hover="" data-delay="0" class="w-dropdown">
                              <div class="dropdown color-blue radiusr-5" style="height:50px"> 
                                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                                      <!-- Country -->
                                      {{ destinationCountryName }} <img [src]="'assets/images/' + destination_currency + '.png'"  class="ml-1" width="22" height="22">
                                      <i class="fas fa-angle-down pl-2"></i>
                                  </button> 
                                  
                                  <div class="dropdown-content"> 
                                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('inr','India', 101)"> 
                                      India
                                      <img alt="INR" src="assets/images/inr.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ghs','Ghana', 83)"> 
                                      Ghana
                                      <img alt="GHS" src="assets/images/ghs.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Benin', 24)"> 
                                      Benin
                                      <img alt="BENIN" src="assets/images/benin.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Senegal', 195)"> 
                                      Senegal
                                      <img alt="XOF" src="assets/images/xof.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('zar','South Africa', 204)"> 
                                      South Africa
                                      <img alt="ZAR" src="assets/images/zar.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('php','Philippines', 174)"> 
                                      Philippines
                                      <img alt="PHP" src="assets/images/php.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ngn','Nigeria', 161)"> 
                                      Nigeria
                                      <img alt="NGN" src="assets/images/ngn.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Burkina Faso', 35)"> 
                                      Burkina Faso
                                      <img alt="NGN" src="assets/images/burkinafaso.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Ivory Coast', 54)"> 
                                      Ivory Coast
                                      <img alt="NGN" src="assets/images/ivorycoast.png" class="ml-1" width="20" height="20">
                                    </a>
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Guinea-Bissau', 93)"> 
                                      Guinea-Bissau
                                      <img alt="NGN" src="assets/images/guineabissau.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                                    </a>
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Mali', 134)"> 
                                      Mali
                                      <img alt="NGN" src="assets/images/mali.png" class="ml-1" width="20" height="20">
                                    </a>
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Niger', 160)"> 
                                      Niger
                                      <img alt="NGN" src="assets/images/niger.png" class="ml-1" width="20" height="20">
                                    </a>
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Togo', 220)"> 
                                      Togo
                                      <img alt="NGN" src="assets/images/togo.png" class="ml-1" width="20" height="20">
                                    </a>
                                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','United Kingdom', 232)"> 
                                      United Kingdom
                                     <img alt="NGN" src="assets/images/gbp.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                                    </a>
                                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('kes','Kenya', 113)"> 
                                      Kenya
                                      <img alt="KES" src="assets/images/kes.png" class="ml-1" width="20" height="20">
                                    </a> 
                                    
                                  </div> 
                              </div>
                              
                          </div>
                      </div>
                  </form>
                  <div class="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div class="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
              </div>
              <a  id="send-money-button" style="background:#266DD3;" routerLink="/dashboard" class="calculator-button w-button w-button-sm14">Send money across borders, the easy way<span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span></a>
              <small *ngIf="!common.isIos" class="text-center mt-3 text10 grey-text">also available for</small>
              <div *ngIf="!common.isIos" class="text-center">
                  <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
                      <img  src="assets/images/google-play.png" class="playStore-img " alt="">
                  </a>
<!-- <p-dialog header="" [closable]="false" [(visible)]="common.visibleIos" [style]="common.respwidth" [modal]="true">
          <h1 class="text-center blue">iOS app coming soon</h1>
          <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="visibleIos=false" label="Ok" styleClass="p-button-text"></p-button>
            </ng-template>
        </p-dialog> -->
                  <a target="blank"  href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
                    <img  src="assets/images/apple_store.png" class="appleStore-img  m-1" alt="">
                  </a>
              </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!(screen_width>996) && offer?.status">
  <div class="d-flex justify-content-center flex-wrap">
      <div class="col-11 px-3 text-center py-2 offer" style="background-color: #A0BF81;color:white" [innerHTML]="offer.subject">
      </div>
      <div class="col-8 px-3 text-center mt-2 py-2 offer" style="background-color: #266DD3;color:white" [innerHTML]="offer.message">
      </div>
  </div>
</div>
<div class="benefits-heading-section">
    <div class="w-container">
      <div class="testimonial-header">
        <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="benefits-chop mb-0">
        <div class="benefits-heading blue"><strong>Benefits of sending money from Canada to EU Countries through N2Xpress</strong></div>
      </div>
    </div>
</div>
<div class="benefits-section">
  <div class="w-container">
    <div class="benefits-body d-flex flex-wrap justify-content-center">
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="pink blue">Remit money to EU Countries to any bank</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">
            Transfer money to EU Countries directly to bank accounts easy and instant with N2Xpress. Pay bills, meet utilities, EMI's, loans, etc at the best exchange rates and lowest transfer fees. Fulfill the demand overseas instantly with N2Xpress instant money transfer service.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="yellow blue">Convenient sending options<br></div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">
            Use multiple sending options and bring convenience to your fingertips. Just select the option for your remittance and your money is transferred conveniently.

          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="purple blue">Keep more money with low transfer fees</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Nominal transfer fees help you save more on transfers so you can do more with money. Pay only $5 when you send up to $1,000 with N2Xpress.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="green blue">Instant transfers globally</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Everyone overseas looks for an instant and cost-effective option for money transfer. Through N2Xpress, money is sent instantly and transferred to the recipient's account.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="purple blue">Unbeatable exchange rates</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Without hidden fees or charges, send money all over the world instantly. Transfer money overseas or to EU Countries with an unbeatable exchange rate and small transfer fees. Select N2Xpress for a fair deal in exchange and remittance to EU Countries.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="green blue">Strong customer support system </div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Our customer care executives are available 24/7 to give you support. Your doubts and queries are settled the same day by our team through the email.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="yellow blue">Simple and secure</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Great rates, nominal transfer fees, excellent support, however, you transfer. We are regulated by the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC). Through our secure and straightforward method, make your money transfer life hassle-free.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="testimonial-section">
  <div class="instruction-container w-container">
    <div class="instruction-header">
      <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
      <div class="section-header-text instructions blue">Steps to send money to EU Countries online</div>
    </div>
    <div class="upper-instructions d-flex flex-wrap">
      <div class="instruction-card _1 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _1 green-royal">1. Create your free account</div>
        <div class="instrucrtion-body">Register online and enter your details for ID verification. Make sure what you enter matches exactly with your identification documents.
        </div>
      </div>
      <div class="instruction-card _2 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _2 green-royal">2. Choose a method</div>
        <div class="instrucrtion-body">Select the currency, country, person, and amount. We’ll show you the exchange rate and total fees upfront for hassle-free transfer to the recipient's account.
        </div>
      </div>
    <!-- </div>
    <div class="lower-instructions"> -->
      <div class="instruction-card _3 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _3 green-royal">3. Input receiver details </div>
        <div class="instrucrtion-body">Tell us the details of the person receiving the money. Make sure it matches their identification documents exactly. Don't worry about all the information you enter as we keep every detail confidential.
        </div>
      </div>
      <div class="instruction-card _4 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _4 green-royal">4. Confirm and send</div>
        <div class="instrucrtion-body">Double-check everything is correct and send your money to the UK. That's it. We'll take care of the rest and tell you when it has arrived. Through email or text, we will notify you.
        </div>
      </div>
    </div>
    <!-- <div class="call-to-action-button">
      <a id="sign-up-button-on-page" routerLink="/register" class="button-3 w-button">Sign up</a>
    </div> -->
  </div>
</div>
<div class="py-5">
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto">
      Sign up 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>

  </a>
</div>
<!-- <div class="cad-to-inr-header-container">
    <h1 class="cad-to-inr-heading"><strong>How to send from Canada to Ghana at lower transfer fees?</strong></h1>
</div>
<div class="batching-section">
    <div class="batching-container w-container">
        <div class="cxy-right">
            <div class="cad-to-inr-description-container">
                <div class="cad-to-inr-description">We compare and give you the best money transfer rates from Canada to Ghana.
                   <br>‍<br>To transfer your Canadian dollars to a bank or mobile money account in Ghanaian cedi  (GHS) in Ghana, the cheapest provider at the moment is N2Xpress with transfer fees at just 1% and a very competitive CAD-GHS conversion rate. Send money to Ghana the smart way.
                  <br></div>
            </div>
        </div>
    </div>
</div> -->
<div class="cad-to-inr-header-container">
    <h1 class="cad-to-inr-heading"><strong>How to get the most out of your remittance to EUR</strong></h1>
  </div>
  <div class="batching-section">
    <div class="batching-container w-container">
      <div class="cxy-right">
        <div class="cad-to-inr-description-container">
          <div class="cad-to-inr-description">Compare cost and fees against convenience, learn how to do money transfer cheaply at your convenience to meet the needs of your loved ones in Europian Union countries.<br></div>
          <ul role="list">
            <li>Exchange rate</li>
          </ul>
          <div class="cad-to-inr-description">The CAD-EUR relation often fluctuates so try to choose a money transfer, which helps you save money by locking in exchange prices.<br></div>
          <ul role="list">
            <li>Transfer fees</li>
          </ul>
          <div class="cad-to-inr-description">Transferring overseas requires fees. But this might be hidden in exchange rates when a service promotes zero transfer fees. Compare fees and try to figure out the best and fair option to save more.<br></div>
          <ul role="list">
            <li>Transfer limits</li>
          </ul>
          <div class="cad-to-inr-description">Every company has a limit on the transfer. How much you can send from a company varies. Different amounts have higher and lower fees. Shop around to meet the needs by choosing wisely.<br></div>
          <ul role="list">
            <li>Turn around</li>
          </ul>
          <div class="cad-to-inr-description">A local bank can take weeks or longer to transfer money overseas. Seek out a digital remittance specialist that offers instant money transfers just like N2Xpress.<br></div>
          <ul role="list">
            <li>Transfer methods</li>
          </ul>
          <div class="cad-to-inr-description">Narrow down a company that matches your preferred delivery criteria. Send money to  Europian Union countries through the cheapest and fastest method, which keeps your life hassle-free.<br></div>
        </div>
      </div>
    </div>
  </div>
<div class="text-center">
  <small *ngIf="!common.isIos" class="text-left mt-3 text10 grey-text">also available for</small>
  <div *ngIf="!common.isIos" class="text-left text-center">
      <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
        <img  src="assets/images/google-play.png" class="playStore-img-large " alt="">
      </a>
      <a target="blank"  href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
        <img  src="assets/images/apple_store.png" class="appleStore-img-large  m-1" alt="">
      </a>
  </div>
</div>
<div class="n2xpress-help-heading instruction-header">
  <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
    <div class="section-header-text instructions blue"><strong>How N2Xpress helps in three ways?</strong></div>
</div>
<div class="n2xpress-help">
    <div class="w-container">
        <div class="benefits-body n2xpress-help-body">
            <div class="cxy-benefit-box w-100">
                <div class="cxy-benefit-header">
                    <div class="pink blue"><strong>Users</strong></div>
                </div>
                <div class="benefit-body">
                    <div class="benefit-body-text gray">Gives options to remittance users to send money to Europian Union countries to their loved ones, friends, and family the best way.
                    </div>
                </div>
            </div>
            <div class="cxy-benefit-box w-100">
                <div class="cxy-benefit-header">
                    <div class="pink"><strong class="yellow blue">Businesses</strong></div>
                </div>
                <div class="benefit-body">
                    <div class="benefit-body-text gray">Businesses can make international payment and global transfer more profitable and easier through N2Xpress.
                    </div>
                </div>
            </div>
            <div class="cxy-benefit-box w-100">
                <div class="cxy-benefit-header">
                    <div class="pink"><strong class="purple blue">Partners </strong></div>
                </div>
                <div class="benefit-body">
                    <div class="benefit-body-text gray">Reach highly valuable remittance audiences easily through marketplaces created by money transfer providers like N2Xpress.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid flags-custom pb-5 pt-5 text-center ">
  <img alt="Send money with N2Xpress" src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0 my-2">
  <div class="text-center">
    
    <div class="currency-header py-2 mb-0">
      <div class="section-header-text new-flag-section" style="color:#2371D3">
          Currencies
      </div>
    </div>
    <div class="custom-currency-intro text-center">
      <div class="text-center new-flag-section my-2">
        We support popular currencies for sending money from Canada and the United States of America. 

        <br></div>
      </div>
      <div class="row mt-5 mx-0">
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="SOUTH AFRICA RAND" src="assets/images/sa-flag.PNG" alt="" class="cursor-pointer" routerLink="/cad-to-zar">
          <div class="row">
            <p class="country-names country-sa pt-1 cursor-pointer" routerLink="/cad-to-zar">South Africa Rand</p>
          </div>
          <div class="row">
            <small class="country-currency">ZAR</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section mt-3 " >
          <img alt="NIGERIA" src="assets/images/nigeria-flag.PNG" alt="Nigeria" class="cursor-pointer" routerLink="/cad-to-ngn">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-ngn">Nigerian Naira</p>
          </div>
          <div class="row">
            <small class="country-currency">NGN</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="PHILIPPINE" src="assets/images/philippine-flag.PNG" alt="Philippine" class="cursor-pointer" routerLink="/cad-to-php">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-php">Philippine Peso</p>
          </div>
          <div class="row">
            <small class="country-currency">PHP</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="KENYA" src="assets/images/kenya-flag.PNG" alt="Kenya" class="cursor-pointer" routerLink="/cad-to-kes">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-kes">Kenyan Shilling</p>
          </div>
          <div class="row">
            <small class="country-currency">KES</small>
          </div>
        </div>
        
      </div>
      <div class="row second-row-flags mx-0 justify-content-center">
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="INDIA" src="assets/images/india-flag.PNG" alt="India" class="cursor-pointer" routerLink="/cad-to-inr">
          <div class="row">
            <p class="country-names country-india pt-1 cursor-pointer" routerLink="/cad-to-inr">Indian Rupee</p>
          </div>
          <div class="row">
            <small class="country-currency">INR</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="SENEGAL" src="assets/images/xof-flag.png" alt="" class="cursor-pointer" routerLink="/cad-to-xof">
          <div class="row">
            <p class="country-names country-senegal pt-1 px-0 text-center w-100 cursor-pointer" routerLink="/cad-to-xof">West African CFA Franc</p>
          </div>
          <div class="row">
            <small class="country-currency">CFA</small>
          </div>
        </div> 
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="GHANA" src="assets/images/ghana-flag.png" alt="Ghana" class="cursor-pointer" routerLink="/cad-to-ghs">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-ghs">Ghanaian Cedi</p>
          </div>
          <div class="row">
            <small class="country-currency">GHS</small>
          </div>
        </div>
        <!-- <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-xof">
          <img src="assets/images/benin-flag.png" alt="Benin">
          <div class="row">
            <p class="country-names country-benin pt-1">Benin</p>
          </div>
          <div class="row">
            <small class="country-currency">CFA</small>
          </div>
        </div>
        
        
         -->
         <!-- <div class="col-md-3 col-12 flags-section  mt-3" >
          <img src="assets/images/mexico-flag.png" alt="Mexico" routerLink="/cad-to-xof" class="cursor-pointer">
          <div class="row">
            <p class="country-names country-benin pt-1 px-0 text-center w-100 cursor-pointer" routerLink="/cad-to-xof">Mexican Peso</p>
          </div>
          <div class="row">
            <small class="country-currency">MXN</small>
          </div>
        </div> -->

        

      </div>
      
    </div>
</div>
<div class="">
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 my-5 text-white calculator-button d-block mx-auto">
      Send money now 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
  <div class="send-money-section">
    <div class="instruction-header send-money-heading-section">
      <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
      <div class="section-header-text instructions blue"><strong>Send money to  Europian Union countries</strong></div>
    </div>
    <div class="box-wrapper">
      <p class="send-money-paragraph-section">Money transfers to  Europian Union countries are not new. Remittances have existed for a long time, but with technological advancement and mobile phones, the experience has become a lot faster and affordable.
         <br>‍<br>
        Over the last few years, Europian Union Countries have seen significant growth in formal remittances channels, a spike in digital remittances, and fast adoption of blockchain technologies.  

        <br><br>N2Xpress has simplified the transfer process through instant online money transfers. We believe unpleasant surprises are not good for both of us so we keep everything 100% transparent. We guarantee you the best-compared exchange rate and nominal fees. You can now send money from Canada to Europian Union Countries using a variety of methods including cards, cheques, bank transfers, and mobile airtime top-ups.

        <br><br>The choice is up to you, but we'll make sure it's fast, convenient, and secure. We always show you the CAD to EUR exchange rates and low fees upfront, without hidden charges. Ever.

        <br></p>
    </div>
  </div>
  <div>
    <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto my-5">
        Sign up
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>

    </a>
  </div>
  <div class="faq-section text-center">
    <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">

    <div class="box-wrapper">
      <div class="faq-heading pt-0 blue">Frequently Asked Questions</div>
      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingTwo">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              What is overseas money transfer? <i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">An overseas money transfer is sending money abroad from the resident country to any overseas country. You can send money to recipients to meet your urgent business or personal needs. It serves various purposes like medical treatment abroad, supporting close relatives, private visits, paying bills, etc. A fast way to transfer money to your loved ones at affordable rates when needed most is using N2Xpress.</p>
        </div>
      </div>
      
      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingThree">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              How does N2Xpress work? <i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">N2Xpress is a digital remittance platform which works on the concept of “Save More &amp; Do More”. We are making it easier to send money globally and provide a world class service that is hassle free. We save remitters money by providing competitive exchange rate and transfer fees.</p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingFour">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              Is it safe to send money online through N2Xpress? <i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">At N2Xpress due care is taken and precaution is exercised to maintain high-level security. We use a compliance process and highest security while transferring. It is important to ensure safety first and to keep information of both the remitter and recipient safe and secure. Check data entered twice and select the transfer option. Stay safe and alert of fraud - in case you receive anything irrelevant related to our service, mail us with details and we will look into it.</p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingFive">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
              What is N2Xpress and how to transfer money to Ghana?<i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">N2Xpress is an online money transfer platform which enables you to send money from Canada to anywhere in Ghana. All you have to do is register on <a routerLink="/">www.n2xpress.com</a> and create a free account. Submit simple verification documents and remit online in just a few taps</p>
        </div>
      </div>
     
      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingSix">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
              How much does it cost to transfer money to Ghana?<i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">Send money in CAD to GHS with a flat fee on different amounts and transactions. N2Xpress shows total cost upfront and so there are no hidden charges or cost. Before transacting, check our minimum transfer fee on every transaction. Maximum limit per transaction is $2999.<br>Transfer fee structure<br>‍<br>$1000             - $5<br>$1001-$1999  - $5<br>$2000-$2999   - $15</p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingSeven">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
              Best online platform to transfer money from Canada to Ghana?<i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">When you want to transfer money from Canada to Ghana, then focus on these key points.<br></p>
          <ul role="list">
            <li>Good exchange rate</li>
            <li>Low transfer fee</li>
            <li>Fastest money transfer</li>
            <li>Multiple options for transfer</li>
            <li>Secure and guaranteed money transfer<br></li>
          </ul>
          <p class="paragraph-2 px-2">When you are looking to transfer Canadian Dollar (CAD) to Ghanian Cedi (GHS) you should keep a few things in mind. There are a number of options available but it’s your call to choose the best online remittance platform with the best currency converter exchange rates.<br></p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingEight">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
              Best rate to transfer CAD and GHS?<i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">For somebody to transfer to Ghana, N2Xpress offers the best deal to transfer Canadian dollar to Ghanaian Cedi. Check out the currency converter at the top of the page to find out today’s rate.</p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingNine">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
              How can I wire money transfer from Canada to Ghana?<i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">Stay connected with your loved ones with N2Xpress by wiring money transfer from Canada to Ghana using a debit card, credit card or airtime top up.</p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingTen">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
              How long does it take to send money to Ghana? <i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">It mostly depends on:<br></p>
          <ul role="list">
            <li>Public holidays or weekends</li>
            <li>Countries you send from</li>
            <li>Security checks</li>
            <li>Payment Methods</li>
          </ul>
          <p class="paragraph-2 px-2">N2Xpress is the cheapest and fastest way to send money to Ghana from Canada. <a routerLink="/register">(sign up link)</a><br><br></p>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingEleven">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
              Which is the fastest and cheapest mode of money transfer to Ghana from Canada? <i class="fas fa-chevron-down ml-auto"></i>
            </h3>
        </div>
        <div id="collapseEleven" class="collapse" aria-labelledby="headingEleven" data-parent="#accordionExample">
          <p class="paragraph-2 px-2">When it comes to international money transfer, you always look for the fastest and most convenient options. N2Xpress meets both the criteria of being the fastest and the cheapest mode of money transfer from Canada to Ghana. The banks are not the best way to transfer money as they are most expensive in terms of fees and exchange rates.</p>
        </div>
      </div>
    </div>
  </div>

<div class="w-embed w-iframe">
    <!--  Google Tag Manager (noscript)  -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NT3DRQ6" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!--  End Google Tag Manager (noscript)  -->
    <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=126238879075083&ev=PageView&noscript=1"></noscript>
</div>

<style>
    .accordion-item-trigger .accordion-icon{
        transition: all 0.2s ease-out; 
    }
    .accordion-item-trigger + .accordion-item-content{
        transition: all 0.2s ease-out; 
    }
</style>

<app-home-footer></app-home-footer>